<template>
  <div>
    <!-- <v-card> -->
    <v-layout row wrap>
      <v-flex
        xs12
        style="
          padding-left: 25px;
          font-weight: bold;
          font-size: 19px;
          cursor: pointer;
          text-align: left;
          padding-top: 10px;
          color: #10aa85;
          border-bottom: 1px solid lightgray;
          padding-bottom: 15px;
        "
      >
        <v-icon
          color="#10AA85"
          style="margin-right: 20px"
          @click="$router.push('/affiliate-d')"
        >
          arrow_back
        </v-icon>
        Transaksi Affiliate
      </v-flex>
      <v-container>
        <v-layout row wrap>
          <v-flex xs6 style="padding-right: 5px">
            <v-select
              v-model="params.type"
              @change="submitFilter()"
              label="Filter"
              :items="transactionTypes"
              single-line
              outline
              required
            >
            </v-select>
          </v-flex>
          <v-flex xs6 style="padding-left: 5px">
            <v-select
              v-model="params.sort_mode"
              @change="submitFilter()"
              label="Sort"
              :items="[
                { text: 'Terbaru', value: 'DESC' },
                { text: 'Terlama', value: 'ASC' },
              ]"
              single-line
              outline
              required
            >
            </v-select>
          </v-flex>
          <v-flex
            xs12
            style="display: flex; flex-flow: row; align-items: center"
          >
            <p style="margin-bottom: 0px">Total Koin:</p>
            <div
              style="
                background-color: #f3f3f3;
                border-radius: 20px;
                padding: 5px 15px 5px 15px;
                margin-left: 10px;
              "
            >
              <b style="color: #00ade2">
                {{ affData.total_coin | currency }}
              </b>
            </div>
          </v-flex>
        </v-layout>
        <div style="margin-top: 5px">
          <v-layout row wrap v-if="listTransaction.length === 0">
            <v-flex
              xs12
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                flex-flow: column;
                color: #494949;
                padding-top: 20%;
              "
            >
              <img
                src="@/assets/icon/affiliate/empty_transaction.svg"
                alt="image-alt"
                style="cursor: pointer; height: 20px"
              />
              Belum ada transaksi komisi
            </v-flex>
          </v-layout>
          <v-layout
            row
            wrap
            style="border-bottom: 1px solid #f0f0f0; padding: 10px 0px 10px 0px"
            v-for="(item, index) in listTransaction"
            :key="index"
          >
            <v-flex xs12 style="display: flex; align-items: center">
              <v-btn
                v-if="item.type === 'REDEEM' && item.status === 'REFUND'"
                style="border-radius: 8px; margin-left: 0px"
                dark
                depressed
                small
                color="#10AA85"
                >Dikembalikan</v-btn
              >
              <v-btn
                v-if="item.type === 'REDEEM' && item.status === 'FAILED'"
                style="border-radius: 8px; margin-left: 0px"
                dark
                depressed
                small
                color="#9C9C9C"
                >Gagal</v-btn
              >
              <v-btn
                v-if="item.type === 'REDEEM' && item.status === 'ONPROGRESS'"
                style="border-radius: 8px; margin-left: 0px"
                dark
                depressed
                small
                color="#face07"
                >Diproses</v-btn
              >
              <img
                v-if="item.status === 'FAILED'"
                src="@/assets/icon/affiliate/note_trx.svg"
                alt="image-alt"
                style="cursor: pointer; height: 20px"
                @click="showNote(item.note)"
              />
            </v-flex>
            <v-flex xs6>
              <b v-if="item.type === 'COMMISSION'">Komisi Affiliate</b>
              <b v-if="item.type === 'REDEEM'">Tarik Saldo</b>
            </v-flex>
            <v-flex xs6 style="text-align: right">
              <b v-if="item.coin > 0" style="color: #00ade2; font-size: 13px"
                >+{{ item.coin | currency }}</b
              >
              <b v-if="item.coin < 0" style="color: #7c7c7c; font-size: 13px">{{
                item.coin | currency
              }}</b>
            </v-flex>
            <v-flex v-if="item.type === 'REDEEM'" xs12>
              Rp {{ item.rupiah | currency }} ({{ item.wallet_type }}
              {{ item.wallet_number }} {{ item.wallet_account }})
            </v-flex>
            <v-flex v-if="item.type === 'COMMISSION'" xs12>
              {{ item.product_title }}
            </v-flex>
            <v-flex xs12 style="color: #7c7c7c">
              {{ item.created_at | moment("DD MMMM YYYY") }}
            </v-flex>
          </v-layout>
          <infinite-loading v-if="listTransaction.length" @infinite="getTxs">
            <div slot="spinner"><v-progress-circular
              :size="30"
              color="primary"
              indeterminate
            ></v-progress-circular></div>
            <div slot="no-more">&nbsp;</div>
            <div slot="no-results">&nbsp;</div>
          </infinite-loading>
        </div>
      </v-container>
    </v-layout>
    <v-dialog v-model="noteDialog" id="confirmationelement" persistent>
      <v-card style="padding: 15px">
        <v-layout row wrap>
          <v-flex xs12 style="text-align: center; margin-bottom: 15px">
            <h2 style="color: #0097d3">Tarik Saldo Gagal</h2>
          </v-flex>
          <v-flex xs12 style="margin-bottom: 15px">
            <p style="margin-bottom: 0px">Catatan :</p>
            <div
              style="
                min-width: 300px;
                min-height: 100px;
                background-color: #f3f3f3;
                border-radius: 5px;
                padding: 12px;
              "
            >
              {{ detailNote }}
            </div>
          </v-flex>
          <v-flex xs3 style="padding: 0px 8px 0px 8px">
            <v-btn
              @click="noteDialog = false"
              color="#10aa85"
              round
              block
              outline
            >
              Oke
            </v-btn>
          </v-flex>
          <v-flex xs9 style="padding: 0px 8px 0px 8px">
            <v-btn color="#10aa85" dark round block @click="toWA()">
              Hubungi Admin
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>
<style>
.v-input__slot {
  border-radius: 30px !important;
}
</style>
<script>
import { getters } from "../../store/modules/affiliate";
import InfiniteLoading from "vue-infinite-loading";
export default {
  name: "affiliate-registration",
  data() {
    return {
      selected: [2],
      noteDialog: false,
      admin: {
        contact_admin_button: {
          link: 'https://www.instagram.com/nfjuara.id'
        },
      },
      affData: { total_coin: 0 },
      listTransaction: [],
      transactionTypes: [],
      detailNote: null,
      params: { type: "", sort_mode: "DESC", page: 1 },
    };
  },
  components: {
    InfiniteLoading,
  },
  filters: {
    currency(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      if(isNaN(val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."))) return 0
      else return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  methods: {
    toWA() {
      window.open(
        this.admin,
        "_blank"
      );
    },
    submitFilter(){
      this.params.page = 1 
      this.listTransaction = []
      this.getTxs()
    },
    getTxs($state) {
      this.$store
        .dispatch("funcGetAffiliateTransaction", this.params)
        .then((response) => {
          if (response.data.data.length > 0) {
            this.affData = response.data;
            this.params.page += 1;
            this.listTransaction.push(...response.data.data);
            $state.loaded();
          } else {
            $state.complete();
          }
          // this.listTransaction = response.data.data;
          //   console.log(response);
        })
        .catch((err) => {
          var error = JSON.parse(JSON.stringify(err));
          if (error.message === "Request failed with status code 404") {
            this.$router.push("/affiliate-r");
          }
        });
    },
    showNote(val) {
      this.detailNote = val;
      this.noteDialog = true;
    },
  },
  created(){
    this.getTxs()
  },
  mounted() {
    this.$store.dispatch("funcGetHelp").then((response) => {
      if (response.status === 200) {
        this.admin = response.data.contact_admin_button.link;
      }
    });
    this.$store.dispatch("funcGetAffiliateTransactionType").then((response) => {
      this.transactionTypes.push({ text: "Semua", value: "" });
      for (let index = 0; index < response.data.length; index++) {
        this.transactionTypes.push({
          text: response.data[index].title,
          value: response.data[index].type,
        });
      }
    });
  },
};
</script>
